import { Controller } from '@hotwired/stimulus'
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  connect() {
    const bs = this._resolveBootstrapLibrary()
    if (bs && bs.Modal) {
      this.modal = bs.Modal.getOrCreateInstance(this.element)
    } else {
      console.error('Bootstrap Modal not found')
    }
  }

  _resolveBootstrapLibrary() {
    // Fallback to window.bootstrap if the module import fails to resolve correctly
    // This handles differences in bundler configurations (esbuild vs others)
    return bootstrap.Modal ? bootstrap : window.bootstrap
  }

  close() {
    if (this.modal) {
      this.modal.hide()
      // Immediately clean up backdrop and body class since Turbo navigation
      // may replace content before Bootstrap's hide animation completes
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
    }
  }

  // A frame render only takes this modal with it when the frame being rendered is one the
  // modal lives in. The page it opens over has frames of its own that answer late - the
  // link and geocode checks land seconds after load - and closing on those shut the dialog
  // under whoever was reading it.
  closeIfReplaced(event) {
    if (event.target.contains(this.element)) {
      this.close()
    }
  }

  // A stream is about to render. Close only when it replaces or updates something this
  // dialog is inside - the archive's own success stream updates profile-frame, which
  // holds the modal - and never for a stream aimed elsewhere on the page. Check again's
  // findings replace lands seconds after its press, while this dialog may be open, and
  // closing on it shut the dialog mid-entry and stripped the backdrop from any other.
  closeIfStreamReplaces(event) {
    const stream = event.detail && event.detail.newStream
    if (!stream) return

    const id = stream.getAttribute('target')
    const selector = stream.getAttribute('targets')
    const targets = id ? [document.getElementById(id)] : selector ? Array.from(document.querySelectorAll(selector)) : []
    if (targets.some((target) => target && target.contains(this.element))) {
      this.close()
    }
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }
}
